import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, Row, Col } from "react-bootstrap";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import AdminNavbar from "../Layout/AdminNavbar";
import ManagerNavbar from "../Layout/ManagerNavbar";
import { FaBullhorn } from "react-icons/fa";
import API_BASE_URL from "../config";

const AlertsLanding = () => {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState({});

  // 🔐 Auth check
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  // 🔐 Fetch permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const token = localStorage.getItem("token");
        const employeeId = localStorage.getItem("employeeId");

        const res = await fetch(
          `${API_BASE_URL}/api/permissions/${employeeId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = await res.json();
        setPermissions(data.pages || {});
      } catch (err) {
        console.error(err);
      }
    };

    fetchPermissions();
  }, []);

  // 🎯 Cards (dynamic based on permission)
  const alertLinks = [
    ...(permissions?.announcement
      ? [
          {
            name: "Announcement",
            path: "/announcement",
            icon: <FaBullhorn size={22} className="text-dark" />,
          },
        ]
      : []),
  ];

  // ── NAVBAR MAP ────────────────────────────────────────────────────────────────
const NAVBAR_MAP = {
    ROLE_ADMIN: AdminNavbar,
    ROLE_MANAGER: ManagerNavbar,
    ROLE_EMPLOYEE: EmployeeNavbar,
};

function RoleNavbar() {
    const PRIORITY = ["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_HR", "ROLE_EMPLOYEE"];
    let selectedRole = "ROLE_EMPLOYEE";

    try {
        const rolesRaw = localStorage.getItem("roles");
        const rolesArray = JSON.parse(rolesRaw); // e.g. ["ROLE_ADMIN"] or ["ROLE_MANAGER"]
        selectedRole = PRIORITY.find(p => rolesArray.includes(p)) || "ROLE_EMPLOYEE";
    } catch {
        selectedRole = "ROLE_EMPLOYEE";
    }

    const NavbarComponent = NAVBAR_MAP[selectedRole] || EmployeeNavbar;
    return <NavbarComponent />;
}

  // Bootstrap load
  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);

    return () => bootstrapLink.remove();
  }, []);

  return (
    <>
      {/* 🔹 Navbar */}
      <div className="fixed-top">
        <RoleNavbar />
      </div>

      {/* 🔹 Page */}
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(135deg, #eef1f7 0%, #ffffff 100%)",
          paddingTop: "140px",
          paddingBottom: "60px",
        }}
      >
        <div className="container-fluid px-5">
          <Row className="align-items-center g-5">
            
            {/* 🟢 LEFT */}
            <Col xs={12} md={5}>
              <h1 className="fw-bold mb-3 text-dark">Alerts & Notifications</h1>
              <p
                className="text-secondary fs-5"
                style={{
                  textAlign: "justify",
                  lineHeight: "1.7",
                  maxWidth: "600px",
                }}
              >
                Stay informed with important updates across the organization.
                The Alerts module helps you view announcements, events, and key
                notifications in one place. Never miss important communication
                from your team or management.
              </p>
            </Col>

            {/* 🔵 RIGHT */}
            <Col xs={12} md={7}>
              <Row xs={2} sm={3} md={3} lg={4} className="g-3">
                {alertLinks.length > 0 ? (
                  alertLinks.map((item, idx) => (
                    <Col key={idx}>
                      <Link
                        to={item.path}
                        className="text-decoration-none text-dark"
                      >
                        <Card className="hover-card text-center py-3 px-2 border-0 shadow-sm">
                          <div className="mb-2">{item.icon}</div>
                          <h6 className="fw-semibold mb-0">{item.name}</h6>
                        </Card>
                      </Link>
                    </Col>
                  ))
                ) : (
                  <div style={{ padding: 20 }}>
                    <p className="text-muted">
                      🚫 No alerts available for your role
                    </p>
                  </div>
                )}
              </Row>
            </Col>
          </Row>
        </div>

        {/* 🎨 Styles */}
        <style>
          {`
          .hover-card {
            background: #fff;
            border-radius: 12px;
            transition: all 0.25s ease;
          }
          .hover-card:hover {
            transform: translateY(-4px) scale(1.03);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
        `}
        </style>
      </div>
    </>
  );
};

export default AlertsLanding;